import GeneralFormPage from '../containers/GeneralFormPage/GeneralFormPage.container';
import GenesisFormPage from '../containers/GenesisFormPage/GenesisFormPage.container';
import BillerPage from '../containers/BillerPage/BillerPage.container';
import InvoicePage from '../containers/InvoicePage/InvoicePage.container';
import TnCPage from '../containers/TnCPage/TnCPage.container';
import TncFormPage from '../containers/TncFormPage/TncFormPage.container';

const Router = [
  {
    id: 5,
    path: '/biller/tnc-form',
    component: TncFormPage,
    exact: true,
  },
  {
    id: 4,
    path: '/tnc',
    component: TnCPage,
    exact: true,
  },
  {
    id: 4,
    path: '/invoice',
    component: InvoicePage,
    exact: true,
  },
  {
    id: 3,
    path: '/genesis',
    component: GenesisFormPage,
    exact: true,
  },
  {
    id: 2,
    path: '/biller/:id',
    component: GeneralFormPage,
    exact: true,
  },
  {
    id: 1,
    path: '/:id',
    component: BillerPage,
    exact: true,
  },
];

export default Router;
